<template>
  <v-dialog v-model="showForm" persistent max-width="500px">
    <AttendanceTherapyFormCard
      :attendance="attendance"
      :therapy="therapy"
      :editView="editView"
      :disabled="disabled"
      @close="toggleShow"
    />
  </v-dialog>
</template>

<script>
import AttendanceTherapyFormCard from "@/components/attendance_therapy/form/card.vue";

export default {
  name: "AttendanceTherapyForm",
  components: {
    AttendanceTherapyFormCard,
  },
  props: {
    attendance: {
      type: Object,
      required: true,
    },
    therapy: {
      type: Object,
      required: false,
    },
    editView: {
      type: Boolean,
      default: false,
    },
    showAttendanceTherapyForm: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    toggleShow: {
      type: Function,
      default: () => {},
    },
  },
  computed: {
    showForm: {
      get() {
        return this.showAttendanceTherapyForm;
      },
      set() {
        this.toggleShow();
      },
    },
  },
};
</script>
